<div fxLayout="row" fxLayoutAlign="start stretch" style="min-height: 100vh">
  <tsa-left-menu style="position: fixed; height: 100%"></tsa-left-menu>
  <div fxFlex="" style="padding-left: 80px;">
    <router-outlet></router-outlet>
  </div>
</div>
